import {
  FETCH_UNTRACED_USERS_LOADING,
  FETCH_UNTRACED_USERS_SUCCESS,
  FETCH_UNTRACED_USERS_FAILURE
} from '../Types/untracedUsersTypes';

const initialState = {
  loading: false,
  success: null,
  data: [],
  error: null
};

const untracedUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UNTRACED_USERS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_UNTRACED_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case FETCH_UNTRACED_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default untracedUsersReducer; 